import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const usePhotos = (albumId = null, options = {}, swrOptions) => {
  const { data, ...rest } = useCustomSWR(
    albumId && `/photos?${stringify({ album: albumId, ...options })}`,
    swrOptions
  )
  // data 會無預期出現nested data，不清楚為什麼，
  // 先避免該狀況出現
  return data?.data ? { data: [], ...rest } : { data, ...rest }
}
